export default __webpack_public_path__ + "static/media/vitalik_poap_5.f59badc3.svg";